import { useMemo, useState } from 'react'
import type { ForecastQuestion } from '../types'
import './MetaculusEmbed.css'

function extractMetaculusId(q: ForecastQuestion): number | null {
  const hay = [q.original_question, q.formatted_question].filter(Boolean).join(' ')
  const m = hay.match(/metaculus\.com\/questions\/(\d+)/i)
  if (!m) return null
  const id = Number(m[1])
  return Number.isFinite(id) ? id : null
}

export default function MetaculusEmbed({ question }: { question: ForecastQuestion }) {
  const [open, setOpen] = useState(true)

  const metaculus = useMemo(() => {
    const id = extractMetaculusId(question)
    if (!id) return null
    const url = `https://www.metaculus.com/questions/${id}/`
    const title = question.formatted_question || `Metaculus question ${id}`
    const embedTitle = encodeURIComponent(title)
    const embedUrl = `https://www.metaculus.com/questions/embed/${id}?theme=light&zoom=all&embedTitle=${embedTitle}`
    return { id, url, embedUrl }
  }, [question])

  if (!metaculus) return null

  return (
    <section className="metaculus-panel">
      <button type="button" className="metaculus-header" onClick={() => setOpen((v) => !v)}>
        <span className="metaculus-toggle">{open ? '▾' : '▸'}</span>
        <span className="metaculus-title">Metaculus community prediction</span>
        <a
          className="metaculus-link"
          href={metaculus.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          View on Metaculus →
        </a>
      </button>
      {open && (
        <div className="metaculus-embed-wrap">
          <iframe
            title={`Metaculus embed ${metaculus.id}`}
            src={metaculus.embedUrl}
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        </div>
      )}
    </section>
  )
}



